import { PatientDetailRoot } from './PatientDetailRoot.graphql';
import { PatientsOverviewRoot } from './PatientsOverviewRoot';
import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

export const PatientsRoot: React.VFC = () => {
    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/:patientId`}>
                <PatientDetailRoot />
            </Route>
            <Route path={`${path}`}>
                <PatientsOverviewRoot />
            </Route>
        </Switch>
    );
};
